import React from 'react';
import { Box, Typography } from '@mui/material';
import SorensonLogo from 'utils/assets/icons/logo.svg';

const LoginHeader = () => {
  return (
    <Box
      id='login-header'
      marginBottom='22px'
      sx={{ color: 'primary.contrastText' }}
    >
      <Box
        id='login-header-logo'
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <img
          alt='Sorenson Logo'
          src={SorensonLogo}
          style={{ width: '130px' }}
        />
      </Box>
      <Typography
        sx={{ fontSize: '24px', fontWeight: '700', margin: '24px 0 16px' }}
      >
        Welcome
      </Typography>
      <Typography sx={{ fontSize: '14px' }}>
        Log in to Sorenson Communications to continue to Sorenson for Zoom.
      </Typography>
    </Box>
  );
};

export default LoginHeader;
